<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Related Hazards & Risks</span>
    <button
      class="navbar-toggler"
      type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <!-- The Add menu holds a create action and the template copy, so it is shown when the user may
             do either. Both the mat-menu and its trigger sit inside the guard, otherwise the menu
             content is still rendered into the CDK overlay. -->
        <ng-container *ngIf="canCreateHazards || canEditAsset">
          <mat-menu #linkMenu="matMenu">
            <button mat-menu-item (click)="onAdd()" *ngIf="canCreateHazards">
              New Hazard
            </button>
            <button mat-menu-item (click)="onCopy()" *ngIf="canEditAsset">
              Select Templates
            </button>
          </mat-menu>

          <button
            class="m-1 mr-2"
            type="button"
            color="primary"
            mat-raised-button
            matTooltip="Add a new or existing Asset Hazard & Risk."
            [matMenuTriggerFor]="linkMenu"
            id="menu-button">
            <mat-icon>add</mat-icon>
            Add Hazard/Risk
          </button>
        </ng-container>

        <!-- Selection drives bulk archive and bulk restore only, both governed by delete. -->
        <ng-container *ngIf="canDeleteHazards">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button *ngIf="dataSource.archived == 'false' && canDeleteHazards" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>archive</mat-icon> Archive Selected
            </button>

            <button *ngIf="dataSource.archived == 'true' && canDeleteHazards" mat-menu-item (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
                <mat-icon>restore</mat-icon> Restore Selected
              </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Asset Hazards & Risks." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options." *ngIf="canViewHazards">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search the Hazards & Risks by name, description or controls."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>

  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let hazard">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(hazard.id) : null"
            [checked]="dataSource.selection.isSelected(hazard.id)"
            matTooltip="Toggle select the record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the Hazard/Risk.">
          #
        </th>
        <td mat-cell *matCellDef="let hazard">
          {{ hazard.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the name of the Hazard/Risk.">Hazard/Risk</th>
        <td mat-cell *matCellDef="let hazard" class="text-wrap">
          <b>{{ hazard.name }}</b> <br />
          <small>{{ hazard.description }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the status of the Hazard/Risk.">Status</th>
        <td mat-cell *matCellDef="let hazard">{{ hazard.status }}</td>
      </ng-container>

      <ng-container matColumnDef="ira_score">
        <th mat-header-cell *matHeaderCellDef matTooltip="Initial Risk Assessment Score">IRA Score</th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
            {{ hazard.ira_score ?? utils.calculateRiskScore(hazard.ira_likelihood, hazard.ira_severity) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ira">
        <th mat-header-cell *matHeaderCellDef matTooltip="Initial Risk Assessment">IRA</th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
            {{ hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity)}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="rra_score">
        <th mat-header-cell *matHeaderCellDef matTooltip="Residual Risk Assessment Score">RRA Score</th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
            {{ hazard.rra_score ?? utils.calculateRiskScore(hazard.rra_likelihood, hazard.rra_severity) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="rra">
        <th mat-header-cell *matHeaderCellDef matTooltip="Residual Risk Assessment">RRA</th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
            {{ hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity)}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="controls">
        <th mat-header-cell *matHeaderCellDef>Controls</th>
        <td mat-cell *matCellDef="let hazard">
          {{ getControlsCount(hazard.controls) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the Hazard/Risk was added.">
          Created At
        </th>
        <td mat-cell *matCellDef="let hazard">
          {{ (hazard.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the Hazard/Risk was added.">
          Created At (UTC)
        </th>
        <td mat-cell *matCellDef="let hazard">
          {{ (hazard.date_created * 1000) | timezoneConvertUTCMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>
        <td mat-cell *matCellDef="let hazard">
          <button *ngIf="dataSource.archived == 'false' && canViewHazards" type="button" mat-button (click)="onView(hazard)">
            View
          </button>
          <button *ngIf="dataSource.archived == 'false' && canEditHazards" type="button" mat-button (click)="onEdit(hazard)">
            Edit
          </button>
          <button *ngIf="dataSource.archived == 'false' && canDeleteHazards" type="button" mat-button (click)="onRemove(hazard.id)">
            Archive
          </button>
          <button *ngIf="dataSource.archived == 'true' && canDeleteHazards" type="button" mat-button (click)="onRestore(hazard.id)">
            Restore
          </button>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
